import type {BioIconProps} from '../common-types'

export function KeyFeaturesIcon({...attributes}: BioIconProps) {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M12.7148 6.16005H4.71484M12.7148 10.7315H4.71484M12.7148 1.58862H4.71484"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.28429 2.73145C1.85572 2.73145 2.42715 2.16003 2.42715 1.5886C2.42715 1.01717 1.85572 0.44574 1.28429 0.44574C0.712864 0.44574 0.142578 1.01717 0.142578 1.5886C0.142578 2.16003 0.712864 2.73145 1.28429 2.73145ZM1.28429 7.30288C1.85572 7.30288 2.42715 6.73145 2.42715 6.16003C2.42715 5.5886 1.85572 5.01717 1.28429 5.01717C0.712864 5.01717 0.142578 5.5886 0.142578 6.16003C0.142578 6.73145 0.712864 7.30288 1.28429 7.30288ZM1.28429 11.8743C1.85572 11.8743 2.42715 11.3029 2.42715 10.7315C2.42715 10.16 1.85572 9.5886 1.28429 9.5886C0.712864 9.5886 0.142578 10.16 0.142578 10.7315C0.142578 11.3029 0.712864 11.8743 1.28429 11.8743Z"
        fill="black"
      />
    </svg>
  )
}
